function WithCashback(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" 
            {...props}
            width={props.size ? props.size : 23.316} height={props.size ? props.size : 23.316} 
            viewBox="0 0 24 24" 
        >
            <path 
                fill="none"
                stroke={props.color ? props.color : "#f6f9fc"}
                d="M4,5c0,0.6,0.4,1,1,1h16c0.6,0,1,0.4,1,1v14c0,0.6-0.4,1-1,1h-5c-0.6,0-1-0.4-1-1s0.4-1,1-1h4V8H5C4.7,8,4.3,7.9,4,7.8V19
                c0,0.6,0.4,1,1,1h5c0.6,0,1-0.4,1-1v-4.6l-1.3,1.3c-0.4,0.4-1,0.4-1.4,0c-0.4-0.4-0.4-1,0-1.4l3-3c0.1-0.1,0.2-0.2,0.3-0.2
                c0.2-0.1,0.5-0.1,0.8,0c0.1,0,0.2,0.1,0.3,0.2l3,3c0.4,0.4,0.4,1,0,1.4c-0.4,0.4-1,0.4-1.4,0L13,14.4V19c0,1.7-1.3,3-3,3H5
                c-1.7,0-3-1.3-3-3V5c0-1.7,1.3-3,3-3h16c0.6,0,1,0.4,1,1s-0.4,1-1,1H5C4.4,4,4,4.4,4,5z"
            />
        </svg>
    );
};
export default WithCashback;